import { render, staticRenderFns } from "./CreateSenderPopup.vue?vue&type=template&id=6df24714"
import script from "./CreateSenderPopup.vue?vue&type=script&lang=js"
export * from "./CreateSenderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports